import React from "react";
import { makeStyles } from "tss-react/mui";
import { Typography, Button, Stepper, Step, StepLabel } from "@mui/material";
import ModalWindow from "./ModalWindow";

const useStyles = makeStyles()((theme: any) => ({
    root: {
        width: "100%",
    },
    button: {
        marginTop: theme.spacing(1),
        marginRight: theme.spacing(1),
    },
    panel: {
        display: "inline-flex",
        flexDirection: "row",
    },
    leftPanel: {
        position: "relative",
        top: -15,
        display: "flex",
        flexDirection: "column",
        width: 200.5,
        borderRight: "solid 1px #F4F4F4",
        alignItems: "center",
    },
    rightPanel: {
        paddingTop: 6,
        display: "flex",
        flexDirection: "column",
        height: "100%",
        width: 437.5,
    },
    header: {
        position: "relative",
        top: 22,
    },
    title: {
        height: 22,
        width: 156,
        color: "#434343",
        fontSize: 20,
        fontWeight: "bold",
        letterSpacing: "0.15px",
    },
    stepper: {
        position: "relative",
        top: 47,
        left: -30,
    },
    step: {
        height: 34,
    },
    stepLabel: {
        height: 17,
        width: 116,
        fontSize: 16,
        lineHeight: 18,
        letterSpacing: "0.5px",
        color: "#002776",
    },
    stepContent: {
        paddingLeft: 27.5,
    },
    footer: {
        position: "absolute",
        right: 20,
        bottom: 12,
    },
}));

type IWizardProps = {
    open: boolean;
    title: string;
    steps: any;
    handleClose: () => void;
    validateStep: (step: number, values: any) => boolean;
    getStepContent: (step: number, setValues: any) => any;
    finalAction: () => void;
};

export default function WizardPanel(props: IWizardProps) {
    const { classes } = useStyles();
    const { open, title, steps, validateStep, getStepContent } = props;
    const [activeStep, setActiveStep] = React.useState(0);
    const [values, setValues] = React.useState();
    const handleClose = () => {
        setActiveStep(0);
        props.handleClose();
    };

    const handleBack = () => {
        if (activeStep === 0) {
            handleClose();
            return;
        }
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleNext = () => {
        if (!validateStep(activeStep, values)) {
            return;
        }
        if (activeStep === steps.length - 1) {
            props.finalAction();
            handleClose();
            return;
        }
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    return (
        <div>
            <ModalWindow open={open} handleClose={handleClose} width={640} height={680}>
                <div className={classes.panel}>
                    <div className={classes.leftPanel}>
                        <div className={classes.header}>
                            <Typography className={classes.title}>{title}</Typography>
                            <Stepper className={classes.stepper} activeStep={activeStep} orientation="vertical">
                                {steps.map((label: string, index: number) => (
                                    <Step className={classes.step} key={label}>
                                        <StepLabel className={classes.stepLabel}>{label}</StepLabel>
                                    </Step>
                                ))}
                            </Stepper>
                        </div>
                    </div>
                    <div className={classes.rightPanel}>
                        <div className={classes.stepContent}>{getStepContent(activeStep, setValues)}</div>
                        <div className={classes.footer}>
                            <Button color="primary" onClick={handleBack} className={classes.button}>
                                {activeStep === 0 ? "Cancel" : "Back"}
                            </Button>

                            <Button variant="contained" color="primary" onClick={handleNext} className={classes.button}>
                                {activeStep === steps.length - 1 ? title : "Next"}
                            </Button>
                        </div>
                    </div>
                </div>
            </ModalWindow>
        </div>
    );
}
